import createAxios from '@/app/core/AxiosCore';
import config from '@/app/config/app';

const axios = createAxios(config);

function listar(params) {
  return axios.get('financeiro/lancamentos', { params }).then((response) => response.data);
}

function abrir(id) {
  return axios.get(`financeiro/lancamentos/${id}`).then((response) => response.data);
}

function salvar(lancamento) {
  return axios.post('financeiro/lancamentos', lancamento).then((response) => response.data);
}

function atualizar(lancamento) {
  return axios.put(`financeiro/lancamentos/${lancamento.id}`, lancamento).then((response) => response.data);
}

function excluir(id) {
  return axios.delete(`financeiro/lancamentos/${id}`).then((response) => response.data);
}

function quitar(id, data_hora_quitacao) {
  return axios.patch(`financeiro/lancamentos/${id}/quitar`, { data_hora_quitacao }).then((response) => response.data);
}

function estornar(id) {
  return axios.patch(`financeiro/lancamentos/${id}/estornar`).then((response) => response.data);
}

function listarPagamentos(id) {
  return axios.get(`financeiro/lancamentos/${id}/pagamentos`).then((response) => response.data);
}

function adicionarPagamento(id, pagamento) {
  return axios.post(`financeiro/lancamentos/${id}/pagamentos`, pagamento).then((response) => response.data);
}

function excluirPagamento(id, pagamentoId) {
  return axios.delete(`financeiro/lancamentos/${id}/pagamentos/${pagamentoId}`).then((response) => response.data);
}

export default {
  listar,
  abrir,
  salvar,
  atualizar,
  excluir,
  quitar,
  estornar,
  listarPagamentos,
  adicionarPagamento,
  excluirPagamento,
};
